import React, { Component } from 'react';
import { EventTemplates as TemplateTypes } from '../../constants/EmailTemplateTypes';

import ReminderForm from '../Reminder/ReminderForm.react';
import EventActions from '../../actions/EventActionCreator';

import EmailTemplateStore from '../../stores/EmailTemplateStore';
import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';
import EventReminderStore from '../../stores/EventReminderStore';

class EventReminderForm extends Component {
    constructor({routeParams}) {
        super(...arguments);
        this.state = {
            templates: null,
            reminderId: (routeParams && Number(routeParams.reminderId)) || null,
        };
        this.onTemplatesChange = this.onTemplatesChange.bind(this);
        this.onReminderChange = this.onReminderChange.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
    }

    componentWillMount(){
        this.listeners = [
            EmailTemplateStore.addListener(this.onTemplatesChange),
            EventReminderStore.addListener(this.onReminderChange),
        ];
        EmailTemplateActions.getByType(TemplateTypes.EVENT_REMINDER);
        if (!!this.state.reminderId) {
            EventActions.getReminder(this.props.routeParams.eventId, this.state.reminderId);
        }
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        const returnUrl = `/dashboard/event/${this.props.routeParams.eventId}/settings`;
        const parameters = {
            title: "New Event Reminder",
            returnUrl: returnUrl,
            onSubmit: this.onSubmitForm
        };
        if (this.state.templates) {
            parameters.templates = this.state.templates;
        }
        if (this.state.reminder) {
            parameters.reminder = this.state.reminder;
        }
        return (
            <ReminderForm {...parameters} />
        )
    }
    
    onSubmitForm(reminder) {
        return EventActions.saveReminder(this.props.routeParams.eventId, reminder);
    }
    
    onTemplatesChange() {
        const templates = EmailTemplateStore.getByType(TemplateTypes.EVENT_REMINDER);
        if (templates) {
            this.setState({templates});
        }
    }

    onReminderChange() {
        const reminder = EventReminderStore.get(this.state.reminderId);
        if (reminder) {
            this.setState({reminder});
        }
    }
}

export default EventReminderForm;
